import React from "react";
import {
  useFetchCustomerOrderDetails,
  useOrderModificationDecision,
  useOrderModificationSummary,
} from "../../hooks/api";
import { useSearchParams } from "react-router-dom";
import {
  MODIFICATION_ORDERS_COLUMN,
  ORDER_MODIFICATION_DECISION,
  ORDER_STATUSES,
} from "../../constants/constants";
import { PAGE_RELOAD_DELAY_MS } from "../../constants/config";
import CustomTable from "../../widgets/Table";
import Loader from "../../components/Loader/Loader";
import { useSnackbarContext } from "../../widgets/CustomSnackBar/CustomSnackBar";
import SecondaryButton from "../../widgets/Button/SecondaryButton/SecondaryButton";

import "./OrderModification.css";

const handleOrderModificationDecision = (openSnackbar, proposalId, orderId, orderModificationDecision, operationType) => {
    const payload = {
      order_id: orderId,
      proposal_id: proposalId,
      operation: operationType,
    };
  orderModificationDecision(payload, {
    onSuccess: () => {
      openSnackbar("Order modification decision", "success");
      window.setTimeout(() => window.location.reload(), PAGE_RELOAD_DELAY_MS);
    },
    onError: (error) => {
      openSnackbar(error.message || "Failed to update order modification decision", "error");
      window.setTimeout(() => window.location.reload(), PAGE_RELOAD_DELAY_MS);
    },
  });
};
const getModificationDetails = (
  modificationRequestOrders,
  openSnackbar,
  proposalId,
  orderId,
  orderModificationDecision,
  isOrderModificationDecisionLoading
) => {
  if (!Array.isArray(modificationRequestOrders)) {
    return [];
  }

  return modificationRequestOrders.map((orderDetails) => ({
    orderId: orderDetails?.order_id ?? "N/A",
    amount: orderDetails?.inr_conversion_amount
      ? Number(orderDetails.inr_conversion_amount).toLocaleString("en-IN")
      : "—",
    orderStatus: orderDetails?.status?.name ?? "Unknown",
    actions: (
      <div className="order-modification-actions">
        {isOrderModificationDecisionLoading ? <Loader /> : (
        <>
        <SecondaryButton
          onClick={() =>
            handleOrderModificationDecision(
              openSnackbar,
              proposalId,
              orderId,
              orderModificationDecision,
              ORDER_MODIFICATION_DECISION.ACCEPT,
            )
          }
        >
          Accept
        </SecondaryButton>
        <SecondaryButton
          onClick={() =>
            handleOrderModificationDecision(
              openSnackbar,
              proposalId,
              orderId,
              orderModificationDecision,
              ORDER_MODIFICATION_DECISION.REJECT
            )
          }
        >
          Reject
        </SecondaryButton>
        </>
        )}
      </div>
    ),
  }));
};

const OrderModification = () => {
  const [searchParams] = useSearchParams();
  const { openSnackbar } = useSnackbarContext();
  const uamId = searchParams.get("uamId");

  const {
    isPending: isOrderDetailsLoading,
    data: orderDetails,
    error: orderDetailsError,
    isError: isErrorFetchingOrderDetails,
  } = useFetchCustomerOrderDetails(uamId);

  const {
    mutate: orderModificationDecision,
    isLoading: isOrderModificationDecisionLoading,
  } = useOrderModificationDecision();

  const modificationRequestOrders =
    orderDetails?.filter(
      (order) => order.status.id === ORDER_STATUSES.SUSPENDED
    ) || [];

  const orderId = modificationRequestOrders[0]?.order_id;
  const hasModificationRequest = modificationRequestOrders.length > 0;
  const {
    data: orderModificationSummary,
    isPending: isOrderModificationSummaryLoading,
    error: orderModificationSummaryError,
  } = useOrderModificationSummary(hasModificationRequest ? orderId : null);

  const proposalId = orderModificationSummary?.proposal_order.id;

  const rows = getModificationDetails(
    modificationRequestOrders,
    openSnackbar,
    proposalId,
    orderId,
    orderModificationDecision,
    isOrderModificationDecisionLoading
  );
  if (isOrderDetailsLoading || isOrderModificationSummaryLoading) {
    return <Loader />;
  }

  return (
    <div className="container">
      <div className="title">Order Modification</div>
      {modificationRequestOrders.length === 0 ? (
        "No modification requests"
      ) : (
        <CustomTable rows={rows} columns={MODIFICATION_ORDERS_COLUMN} />
      )}
      {isErrorFetchingOrderDetails && (
        <div style={{ color: "red" }}>{orderDetailsError.message}</div>
      )}
    </div>
  );
};

export default OrderModification;
